import { useState, type ReactNode } from "react";
import { createNavigationStore, PageHeaderNavigationContext } from "./pageHeaderNavigation";

/** Seitenweiter Zustand für vorhandenes Rücksprungziel und primären Titel; keine Routerabhängigkeit. */
export function PageHeaderNavigationProvider({ children }: { children: ReactNode }) {
  const [store] = useState(createNavigationStore);
  return <PageHeaderNavigationContext.Provider value={store}>{children}</PageHeaderNavigationContext.Provider>;
}
